const create = (api) => {
  const getOSSAgreement = () => {
    // Legal isn't inside the API umbrella, so we need to remove '/api' 
    let baseURL = api.getBaseURL();
    if (baseURL.endsWith('/api')) {
      baseURL = baseURL.slice(0, -4); 
    }
    return api.get(baseURL + '/legal:agreement');
  }

  return {
    getOSSAgreement
  }
}

export default {
  create
};
